import {
  articleIdSchema,
  authorSchema,
  contentSchema,
  nookIdSchema,
  passwordSchema,
  secretSchema,
  tokenSchema,
  versionSchema,
  themeSchema,
} from './schemas';

export const validateId = (
  id: string
): {
  success: boolean;
  errorMessage: string;
  nookId?: string;
} => {
  const result = nookIdSchema.safeParse(id);

  if (result.success) {
    return {
      success: true,
      nookId: result.data,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validatePassword = (
  password: string
): {
  success: boolean;
  errorMessage: string;
  nookPassword?: string;
} => {
  const result = passwordSchema.safeParse(password);

  if (result.success) {
    return {
      success: true,
      nookPassword: result.data,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateToken = (
  token: string
): {
  success: boolean;
  errorMessage: string;
} => {
  const result = tokenSchema.safeParse(token);

  if (result.success) {
    return {
      success: true,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateVersion = (
  version: number
): {
  success: boolean;
  errorMessage: string;
} => {
  const result = versionSchema.safeParse(version);

  if (result.success) {
    return {
      success: true,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateContent = (
  content: string
): {
  success: boolean;
  errorMessage: string;
} => {
  const result = contentSchema.safeParse(content);

  if (result.success) {
    return {
      success: true,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateAuthor = (
  author: string
): {
  success: boolean;
  errorMessage: string;
} => {
  const result = authorSchema.safeParse(author);

  if (result.success) {
    return {
      success: true,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateSecret = (
  secret: string
): {
  success: boolean;
  errorMessage: string;
} => {
  // First validate the format of the secret
  const result = secretSchema.safeParse(secret);

  if (!result.success) {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }

  // Then check if it matches the environment variable
  const envSecret = process.env.SECRET;

  if (!envSecret) {
    return {
      success: false,
      errorMessage: 'Server configuration error: SECRET is not set',
    };
  }

  if (secret !== envSecret) {
    return {
      success: false,
      errorMessage: 'Invalid secret provided',
    };
  }

  return {
    success: true,
    errorMessage: '',
  };
};

export const validateArticleId = (
  id: number
): {
  success: boolean;
  errorMessage: string;
} => {
  // First validate the format of the secret
  const result = articleIdSchema.safeParse(id);

  if (result.success) {
    return {
      success: true,
      errorMessage: '',
    };
  } else {
    return {
      success: false,
      errorMessage: result.error.errors[0].message,
    };
  }
};

export const validateTheme = (theme: string): boolean => {
  try {
    themeSchema.parse(theme);
    return true;
  } catch {
    return false;
  }
};
